module.exports = __webpack_public_path__ + "static/media/b_jugend_min.6c16c2c4.jpg";